export default {
  name: "wishlistHeaderSection",
  methods:{
    followersNumber(){
      return this.$store.getters.getUserInfo.followers
    }
  }
};
